import React, { useState, useEffect } from 'react'
import { navigate } from 'gatsby'
import Button from '../../atoms/button/button'
import ButtonClose from '../../atoms/button-close/button-close'
import { siteUrl } from '../../../shared/utils/siteUrl'
import imgCard from '../../../assets/images/common-modal/redeem/card.svg'
import imgStickers from '../../../assets/images/common-modal/redeem/stickers.png'
import imgWallPapers from '../../../assets/images/common-modal/redeem/wallpapers.png'

import useMediaQuery from '../../../utils/useMediaQuery'
import { pushEventData } from '../../../utils/pushEventDataLayer'

import {
  activities,
  costActivity,
  LOCALE,
  TROPICALIZED,
} from '../../../constants/activity-constants'

import CompetitionService from '../../../shared-campaign/services/competition'
import AuthService from '../../../shared/services/auth-service'

import RedeemService from '../../../services/redeem-service'
import getUserInfo from '../../../utils/getUserInfo'

import './modalRedeem.scss'
import userSessionStorage from '../../../utils/userSessionStorage'
import Show from '../../../utils/show'

const KeysComp = ({ onPointesAdded, metric }) => {
  const isMobile = useMediaQuery()
  const [isLoadingPoints, setIsLoadingPoints] = useState(false)
  const [errorMessageKeys, setErrorMessageKeys] = useState(false)
  const [myKey, setMyKey] = useState('')

  const handleErrorMessage = message => {
    setErrorMessageKeys(message)
    setTimeout(() => {
      setErrorMessageKeys('')
    }, 6000)
  }
  const handleAquirePoints = async e => {
    if (isLoadingPoints) {
      return null
    }
    e.preventDefault()

    if (myKey === '') {
      handleErrorMessage('Ingresa primero una clave')
    } else {
      setIsLoadingPoints(true)
      setErrorMessageKeys(false)
      let redeemRes = await CompetitionService.postRedeemKeyWithoutPoints(0, {
        activity: 'curv-boom',
        key: { code: myKey },
        country: parseInt(process.env.COUNTRY_CODE),
      })
      if (redeemRes.status === 200) {
        setIsLoadingPoints(false)
        //setPointsUser(points => points + redeemRes.data.points)
        onPointesAdded && onPointesAdded(redeemRes.data.points)
        setMyKey('')
      } else {
        handleErrorMessage(redeemRes.userMessage)
        setIsLoadingPoints(false)
      }
    }
  }

  return (
    <section className="f-modalRedeem-container__setKeys">
      <p className="f-modalRedeem-container__setKeys__textInfoKeys">
        <span>
          {' '}
          ¿No {TROPICALIZED ? 'tenés' : 'tienes'} puntos para{' '}
          {['es-PE', 'es-CL'].includes(LOCALE) ? 'canjear' : 'redimir'}?
        </span>
        <br />
        {TROPICALIZED ? 'Inscribí acá' : 'Inscribe aquí'} las claves de tus{' '}
        {isMobile && <br />} productos {!isMobile && <br />} Nosotras y{' '}
        {TROPICALIZED ? 'acumulá' : 'acumula'} {isMobile && <br />}puntos para
        participar.
      </p>
      <div className="f-modalRedeem-container__setKeys__inputAndButton">
        <input
          placeholder="Digita Tus Claves"
          value={myKey}
          disabled={isLoadingPoints}
          onChange={e => {
            setMyKey(e.target.value)
          }}
        />
        <Button
          className="f-buttonActivity --right"
          disabled={isLoadingPoints}
          loading={isLoadingPoints}
          metric={metric}
          onClick={e => handleAquirePoints(e)}
          text="Enviar"
        />
      </div>
      {errorMessageKeys && <p className="f-errorMessage">{errorMessageKeys}</p>}
      <a
        target="_BLANK"
        href={siteUrl + '/mis-puntos/ingreso-de-claves/'}
        onClick={e => {
          pushEventData({ ...metric, label: e.target.innerText })
        }}
      >
        Quiero saber cómo {isMobile && <br />}ingresar mis claves
      </a>
    </section>
  )
}

const ModalRedeem = props => {
  const { activity, onSuccess, onClose } = props

  const isMobile = useMediaQuery()

  const [session] = useState(new userSessionStorage())
  const [pointsUser, setPointsUser] = useState('')

  const [isLoading, setIsLoading] = useState(false)
  const [errorMessageRedeem, setErrorMessageRedeem] = useState(false)
  const userInfo = getUserInfo()
  const handleErrorMessage = message => {
    setErrorMessageRedeem(message)
    setTimeout(() => {
      setErrorMessageRedeem('')
    }, 6000)
  }
  const ACTIVITY_ID = activities[activity]
  const COST = costActivity[activity]
  const TITLE = {
    card: TROPICALIZED ? 'Descargá tu tarjeta' : 'Descarga tu tarjeta',
    stickers: TROPICALIZED
      ? 'Descargá tu pack de stickers'
      : 'Descarga tu pack de stickers',
    wallpapers: TROPICALIZED
      ? 'Descargá tu wallpaper'
      : 'Descarga tu wallpaper',
  }[activity]
  const IMAGE = {
    card: imgCard,
    stickers: imgStickers,
    wallpapers: imgWallPapers,
  }[activity]
  const txtInfoBO = {
    card: (
      <>
        Ya casi está todo listo, solo debes descargar la tarjeta y enviarla a
        los que más quieres. <b>¡Felices fiestas!</b>
      </>
    ),
    stickers: (
      <>
        Ya casi está todo listo, solo debes descargar tus stickers para tenerlos
        en tu WhatsApp y enviarlos a los que más quieres.{' '}
        <b>¡Felices fiestas!</b>
      </>
    ),
    wallpapers: (
      <>
        Ya casi está todo listo, solo debes descargar tu wallpaper para
        personalizar tu celular y tu computador en esta época tan especial.
        <b>¡Felices fiestas!</b>
      </>
    ),
  }[activity]
  const handleCancel = () => {
    if (onClose) {
      onClose()
    }
  }
  const handleSuccess = () => {
    onSuccess()
  }
  const handleRedimir = isTokenActivo => {
    if (isLoading) {
      return
    }

    // if(COST<=0){
    //   reedemSuccess();
    //   return
    // }

    setIsLoading(true)
    setErrorMessageRedeem(false)
    let points = pointsUser
    if (points < COST) {
      handleErrorMessage('No hay suficientes puntos.')
      setIsLoading(false)
      return
    }
    let tokenId = session.getToken().idToken
    let config = {
      headers: {
        Authorization: tokenId,
      },
    }
    try {
      RedeemService.postRedeem(ACTIVITY_ID, config).then(
        response => {
          //--- console.log(response)
          setIsLoading(false)
          if (response.status === 400) {
            handleErrorMessage(
              'Algo ha salido mal con la petición, inténtalo de nuevo'
            )
            return
          }

          handleSuccess()
        },
        error => {
          console.warn(error)
          handleErrorMessage(
            'Algo ha salido mal con la petición, inténtalo de nuevo'
          )
          setIsLoading(false)
        }
      )
    } catch (error) {
      console.warn(error)
      handleErrorMessage(
        'Algo ha salido mal con la petición, inténtalo de nuevo'
      )
      setIsLoading(false)
    }
  }
  const formatNumber = number => {
    if (number === '0') return 0
    if (number) return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return 0
  }

  const puntosRombo = points => {
    return (
      <span className="f-romboPuntosRedeem">
        <b className="f-romboPuntosRedeem__numero">{formatNumber(points)}</b>
      </span>
    )
  }

  // load user info
  useEffect(() => {
    let userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
    if (userInfo) {
      let tokenId = session.getToken().idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }
      AuthService.sessionInfo(config).then(res => {
        if (res.status === 200) {
          setPointsUser(
            res.data.userPoints.pointsAccumulation +
              res.data.userPoints.pointsPresent
          )
        } else {
          setPointsUser(
            userInfo.userPoints.pointsAccumulation +
              userInfo.userPoints.pointsPresent
          )
        }
      })
    } else {
      navigate('/')
    }
  }, [])
  const figureImg = (
    <figure className="f-modalRedeem-container__figure">
      <img
        className="f-modalRedeem-container__image"
        src={IMAGE}
        alt="chicas reunidas en el login"
      />
    </figure>
  )

  const METRIC = (() => {
    const event = {
      stickers: 'Interacciones_Stickers',
      wallpapers: 'Interacciones_Diseño_Wallpaper',
      card: 'Interacciones_Diseño_Tarjeta',
    }[activity]

    const category = {
      stickers: 'Descarga tu pack de stickers',
      wallpapers: 'Descarga tu wallpaper',
      card: 'Descarga tu tarjeta',
    }[activity]

    return {
      event,
      category,
      action: 'click',
      Location: 'nosotras.com/navidad',
      user_data: [
        {
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        },
      ],
      log_status: 'Yes',
    }
  })()
  return (
    <div className="f-modalRedeem-container">
      <div className="f-modalRedeem-container__wrapper">
        <ButtonClose onClick={handleCancel} />
        {!isMobile && figureImg}
        <aside className="f-modalRedeem-container__aside">
          <section className="f-modalRedeem-container__infoRedeem">
            <h2 className="f-modalRedeem-container__title">{TITLE}</h2>
            {isMobile && figureImg}
            <p
              className={`f-modalRedeem-container__text --redimir ${
                LOCALE === 'es-BO' && '--txtInfoBO'
              }`}
            >
              {LOCALE === 'es-BO' ? (
                txtInfoBO
              ) : (
                <>
                  Para descargarla{' '}
                  {TROPICALIZED || ['es-PE', 'es-CL'].includes(LOCALE)
                    ? 'debés canjear'
                    : 'debes redimir'}
                  {puntosRombo(COST)}
                </>
              )}
            </p>
          </section>
          <section className="f-modalRedeem-container__button_actions">
            <Show valid={pointsUser >= COST}>
              <Button
                className="f-buttonActivity btnRedimir"
                disabled={isLoading}
                loading={isLoading}
                metric={METRIC}
                onClick={() => {
                  handleRedimir(false)
                }}
                text={
                  LOCALE === 'es-BO'
                    ? 'Descargar'
                    : TROPICALIZED || ['es-PE', 'es-CL'].includes(LOCALE)
                    ? 'Canjear'
                    : 'Redimir'
                }
              />
            </Show>
            <Show valid={pointsUser < COST}>
              <span className="f-errorMessage"> No te alcanzan los puntos</span>
            </Show>

            <Button
              className="f-buttonActivity btnRedimir"
              disabled={isLoading}
              loading={isLoading}
              onClick={handleCancel}
              metric={METRIC}
              text={'Volver'}
            />
            {errorMessageRedeem && (
              <span className="f-errorMessage">{errorMessageRedeem}</span>
            )}
          </section>
          {LOCALE !== 'es-BO' && (
            <KeysComp
              metric={METRIC}
              onPointesAdded={_points => {
                setPointsUser(points => points + _points)
              }}
            />
          )}
        </aside>
      </div>
    </div>
  )
}

export default ModalRedeem
